const submitForm1262DataToMarketo = require("../../run/form1262/submitForm1262DataToMarketo");
const getForm1262ReturningUserData = require("../../run/form1262/getForm1262ReturningUserData");

/**
 * @returns {void}
 */
module.exports = async function whenForm1262ReturningUserCtaClicked() {
    const formData = getForm1262ReturningUserData();

    if (formData) {
        await submitForm1262DataToMarketo(formData);
    }
};